/**
 * Inicializaión de la interfaz IProductsModel
 *
 * *Set IProductsModel interface*
 *
 * @access public
 * @type {class}
 */
export class OccupationModel {
  /**
   * Nombre de la ocupación
   *
   * *Occupation's name*
   *
   * @var {string} name
   */
  name: string;

  /**
   * Ícono de la ocupación
   *
   * *Occupation's icon*
   *
   * @var {string} icon
   */
  icon: string;

  /**
   * Estado de la ocupacion (verdadero o falso)
   *
   * *Occupation's state (true or false)*
   *
   * @var {boolean} active
   */
  active: boolean;

  /**
   * Selección del usuario de la ocupación
   *
   * *User´s occupation selection*
   *
   * @var {boolean} selected
   */
  selected: boolean;

  /**
   * Ingresos mínimos infligido de la ocupación
   *
   * *Occupation minimun Inflicted Incomes*
   *
   * @var {number} minimun_inflicted_incomes
   */
  minimun_inflicted_incomes: number;

  /**
   *
   * ciiu
   *
   * @var {string} ciiu
   */
  ciiu: string;

  /**
   * Identificación de la ocupación
   *
   * *Ocuppation's identificaction*
   *
   * @var {number} id
   */
  id: number;

  /**
   * Flujo de navegación de la ocupación
   * *Occupation's Flow navigation'
   *
   * @var {number} occupation_flow
   */
  occupation_flow: number;

  /**
   * Mesnaje de ingresos
   *
   * *Incomes Message*
   *
   * @var {string} incomes_msg
   */
  incomes_msg?: string;
}
